import request from '@/common/request/request_common'

function buy(data) { return request({ url: '/TenantService/Buy', method: 'post', data }) }
function getOne(data) { return request({ url: '/TenantService/GetOne', method: 'post', data }) }

function wxPayQrCode(data) {
  return request({
    url: '/WxPay/Native',
    method: 'post',
    data
  })
}
function wxPayPreId(data) {
  return request({
    url: '/WxPay/CreateOrderByJsapi',
    method: 'post',
    data
  })
}

export default {
  buy,
  getOne,
  wxPayQrCode,
  wxPayPreId
}
